import {connect} from 'react-redux';

import {isElectron} from '../../../../libs/shared/helpers/src/environment/platformHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {makeHasComposeChannel} from '../../../store/data/channels/channelsSelectors';
import {composeCommentAction} from '../../../store/data/comments/commentsActions';
import {getHasInternalDiscussions, getHasTrialExpired} from '../../../store/data/company/companySelectors';
import {composeMessageAction} from '../../../store/data/messages/draftMessagesActions';
import {getHasUserTeamTrialExpired} from '../../../store/data/teams/teamsSelectors';
import {ComposeButton} from './composeButton';

/*
 * Props.
 */

interface ComposeButtonContainerProps {
  selectedInboxId?: number;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ComposeButtonContainerProps>()(() => ({
  canCompose: makeHasComposeChannel(),
  canComposeInternal: getHasInternalDiscussions,
  hasTrialExpired: getHasTrialExpired,
  hasUserTeamTrialExpired: getHasUserTeamTrialExpired,
}));

const mapDispatchToProps = makeMapDispatchToProps<ComposeButtonContainerProps>()(({selectedInboxId}) => ({
  onComposeClick: () => composeMessageAction({selectedInboxId, shouldForcePopout: isElectron()}),
  onComposeInternalClick: composeCommentAction,
}));

export const ComposeButtonContainer = connect(mapStateToProps, mapDispatchToProps)(ComposeButton);
